import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { RiCloseLargeFill } from "react-icons/ri";
import { MdLockReset } from "react-icons/md";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";

const ResetPasswordModal = ({
  show,
  onClose,
  onConfirm,
  title = "Reset Password",
  userName = "",
  loading = false,
}) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    if (!show) {
      setPassword("");
      setConfirmPassword("");
      setError("");
    }
  }, [show]);

  const handleSubmit = () => {
    if (!password || !confirmPassword) {
      setError("Please enter and confirm the new password.");
      return;
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setError("");
    onConfirm(password);
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      size="sm"
    >
      <div className="modal-header border-0 pb-0">
        <h5 className="modal-title">{title}</h5>
        <button className="btn" onClick={onClose} disabled={loading}>
          <RiCloseLargeFill size={20} />
        </button>
      </div>
      <hr className="my-1" />

      <Modal.Body>
        <div className="text-center mb-3">
          <MdLockReset size={32} />
        </div>
        {userName && (
          <p className="mb-2">
            Set a new password for <strong>{userName}</strong>.
          </p>
        )}
        <div className="mb-2">
          <label className="form-label">New Password</label>
          <div className="input-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              placeholder="Enter new password"
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword((v) => !v)}
              tabIndex={-1}
              title={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
            </button>
          </div>
        </div>
        <div className="mb-2">
          <label className="form-label">Confirm Password</label>
          <div className="input-wrapper">
            <input
              type={showConfirmPassword ? "text" : "password"}
              className="form-control"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              disabled={loading}
              placeholder="Confirm new password"
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowConfirmPassword((v) => !v)}
              tabIndex={-1}
              title={showConfirmPassword ? "Hide password" : "Show password"}
            >
              {showConfirmPassword ? <MdVisibilityOff /> : <MdVisibility />}
            </button>
          </div>
        </div>
        {error && <div className="admin_error-text mt-1">{error}</div>}
      </Modal.Body>

      <div className="modal-footer border-0 justify-content-center">
        <button
          className="btn btn-light px-4"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          className="btn btn-primary px-4"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Saving..." : "Reset Password"}
        </button>
      </div>
    </Modal>
  );
};

export default ResetPasswordModal;

